"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickFreeModuleCancelSchema = void 0;
const signUpModal_1 = require("modules/content/moduleEditor/components/free/signUpModal/signUpModal");
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickFreeModuleCancelSchema extends baseClickSchema_1.BaseClickSchema {
    constructor() {
        super({ componentName: 'FreeModuleModalCancelButton' });
        this.step = signUpModal_1.ViewFreeModuleSteps.FREE_MODULE_ACTIVATE;
        this.action = baseSchema_1.ActionsName.CLICK_FREE_MODULE_CLOSE;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            step: this.step,
            action: this.action
        };
    }
}
exports.ClickFreeModuleCancelSchema = ClickFreeModuleCancelSchema;
